// extracted by mini-css-extract-plugin
module.exports = {"submitSaveAndSend":"_1rX-JsR609te5xHtWKmsdB button success"};